/**
 * Telefones brasileiros → E.164 sem "+", ex.: 5511912345678.
 * Normalizar ANTES de calcular o blind index: "(11) 91234-5678" e "+55 11 91234 5678" são o mesmo contato.
 */
export function normalizeBrPhone(raw) {
    let d = raw.replace(/\D/g, '');
    if (d.startsWith('00'))
        d = d.slice(2);
    if (d.length === 10 || d.length === 11)
        d = `55${d}`;
    if (!d.startsWith('55') || (d.length !== 12 && d.length !== 13))
        return null;
    const ddd = Number(d.slice(2, 4));
    if (ddd < 11 || ddd > 99)
        return null;
    // celular (13 dígitos) começa com 9 após o DDD
    if (d.length === 13 && d[4] !== '9')
        return null;
    return d;
}
/** "(11) •••••-5678" — exibição sem revelar o número inteiro. */
export function maskPhone(e164OrLast4, ddd) {
    const last4 = e164OrLast4.slice(-4);
    const area = ddd ?? (e164OrLast4.length >= 12 ? e164OrLast4.slice(2, 4) : '••');
    return `(${area}) •••••-${last4}`;
}
/** Máscara de digitação: "11912345678" → "(11) 91234-5678". */
export function formatBrPhoneInput(digits) {
    const d = digits.replace(/\D/g, '').slice(0, 11);
    if (d.length <= 2)
        return d.length ? `(${d}` : '';
    if (d.length <= 6)
        return `(${d.slice(0, 2)}) ${d.slice(2)}`;
    if (d.length <= 10)
        return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
    return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}
//# sourceMappingURL=phone.js.map